<template>
  <details-header :loading="loading">
    <template v-slot:avatar>
      <avatar :avatarUrl="$images.STRATEGIC_ANCHOR_BADGE" :size="100"></avatar
    ></template>
    <template v-slot:headerLine1>
      Strategic Anchors
    </template>
    <template v-slot:headerLine2>
      {{ strategic_anchors.length }} anchors
    </template>
    <v-row>
      <v-col cols="12">
        <strategic-anchor-form
          v-on:save="saveStrategicAnchors"
        ></strategic-anchor-form>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import StrategicAnchorForm from "@/components/company/StrategicAnchorForm";
import DetailsHeader from "@/components/common/DetailsHeader";
export default {
  name: "StrategicAnchors",
  components: {
    DetailsHeader,
    StrategicAnchorForm
  },
  data: () => ({
    tab: null,
    loading: false
  }),
  watch: {},
  computed: {
    ...mapGetters({
      strategic_anchors: "company/strategic_anchors"
    })
  },
  created() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch("company/getStrategicAnchors", this.$route.params.id)
    ])
      .catch(error => {
        this.logError(error);
        this.$root
          .$alert("Error Occurred", "An error occured while loading")
          .then(() => {
            this.$router.push({ path: "/company" });
          });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    saveStrategicAnchors() {
      if (this.$route.query.returnUrl) {
        this.$router.push({ path: this.$route.query.returnUrl });
      } else {
        this.$router.push({ path: "/company" });
      }
    }
  }
};
</script>
